import React from 'react'
import { Box, Alert, AlertIcon, AlertTitle, AlertDescription, Button, Code, Stack } from '@chakra-ui/react'

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Box p={5}>
      <Alert status="error" variant="solid" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" height="auto" p={4}>
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Ocorreu um erro!
        </AlertTitle>
        <AlertDescription maxWidth="lg">
          <Stack spacing={3}>
            <Box>{error.message}</Box>
            <Box>
              <Code colorScheme="red" p={2} borderRadius="md" fontSize="sm" whiteSpace="pre-wrap">
                {error.stack}
              </Code>
            </Box>
            <Button colorScheme="red" variant="outline" onClick={resetErrorBoundary}>
              Tentar novamente
            </Button>
          </Stack>
        </AlertDescription>
      </Alert>
    </Box>
  )
}

export default ErrorFallback
